import React, { Fragment, memo, useContext, useEffect, useState } from "react";

import { AppContext } from "../../../components/AppProvider";
import { ConfirmLayer } from "../../../components/UI/Dialog";
import {
  PostApi211,
  PostApi213,
  PostApi214,
  PostApi216,
  PostApi261,
  PostApi262,
  PostApi263,
  PostApi264,
  PostApi999,
} from "../../../modules/network/padoPost";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { userHabit } from "../../../modules/utils/UserHabit";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import {
  AlertPopup,
  closeLayerFn,
  Container,
  DetailPopup,
  openAlertPopup,
  openLayerFn,
} from "../../Layout";
import BtnAdd from "./Component/BtnAdd";
import Contents from "./Component/Contents";
import ListDetailPopup from "./Component/ListDetailPopup";
import ListPopup from "./Component/ListPopup";
import Nothing from "./Component/Nothing";
import Search, {
  AllergyImgList,
  ContentsList,
  SearchDefaultMdcn,
} from "./Component/Search";
import { SubMenu, SUBS } from "./Component/SubMenu";

const allergyFood = [
  {
    code: "F01",
    text: "메밀",
    img: "alg_img alg_01",
  },
  {
    code: "F02",
    text: "밀",
    img: "alg_img alg_02",
  },
  {
    code: "F03",
    text: "대두",
    img: "alg_img alg_03",
  },
  {
    code: "F05",
    text: "복숭아",
    img: "alg_img alg_05",
  },
  {
    code: "F04",
    text: "견과류",
    img: "alg_img alg_04",
  },
  {
    code: "F06",
    text: "토마토",
    img: "alg_img alg_06",
  },
  {
    code: "F07",
    text: "난류",
    img: "alg_img alg_07",
  },
  {
    code: "F08",
    text: "육류",
    img: "alg_img alg_08",
  },
  {
    code: "F09",
    text: "우유",
    img: "alg_img alg_09",
  },
  {
    code: "F10",
    text: "갑각류",
    img: "alg_img alg_10",
  },
  {
    code: "F11",
    text: "고등어",
    img: "alg_img alg_11",
  },
  {
    code: "F12",
    text: "오징어",
    img: "alg_img alg_12",
  },
  {
    code: "F13",
    text: "조개류",
    img: "alg_img alg_13",
  },
  // {
  //     code: 'F14',
  //     text: '굴, 전복, 홍합',
  //     img: 'alg_img alg_14'
  // },
  {
    code: "F15",
    text: "아황산포함식품",
    img: "alg_img alg_14",
  },
  {
    code: "F90",
    text: "기타",
    img: "alg_img alg_15",
  },
];

const allergyEtc = [
  {
    code: "E01",
    text: "꽃가루",
    img: "alg_img_etc alg_01_etc",
  },
  {
    code: "E02",
    text: "동물털",
    img: "alg_img_etc alg_02_etc",
  },
  {
    code: "E03",
    text: "곰팡이",
    img: "alg_img_etc alg_03_etc",
  },
  {
    code: "E04",
    text: "진득이",
    img: "alg_img_etc alg_04_etc",
  },
  {
    code: "E05",
    text: "먼지",
    img: "alg_img_etc alg_05_etc",
  },
  {
    code: "E06",
    text: "식물",
    img: "alg_img_etc alg_06_etc",
  },
  {
    code: "E07",
    text: "금속",
    img: "alg_img_etc alg_07_etc",
  },
  {
    code: "E08",
    text: "라텍스",
    img: "alg_img_etc alg_08_etc",
  },
  {
    code: "E90",
    text: "기타",
    img: "alg_img_etc alg_09_etc",
  },
];

export default memo(() => {
  const { userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);

  const [searchMode, setSearchMode] = useState(0); // 일반:0 검색:1
  const [saveMode, setSaveMode] = useState(0); // 저장:0 수정:1
  const [allergyList, setAllergyList] = useState();
  const [allergyType, setAllergyType] = useState(0);
  const [resultList, setResultList] = useState();
  const [searchList, setSearchList] = useState();
  const [pageNo, setPageNo] = useState(1);
  const [pageCnt, setPageCnt] = useState(999);

  const [foodId, setFoodId] = useState();
  const [medicineId, setMedicineId] = useState();
  const [allergyId, setAllergyId] = useState();
  const [medicineText, setMedicineText] = useState();

  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
    allergyId: "",
  });

  let subType;

  if (allergyType === 0) {
    subType = 0;
  } else if (allergyType === 1) {
    subType = 2;
  } else if (allergyType === 2) {
    subType = 1;
  } else if (allergyType === 9) {
    subType = 3;
  }
  // allergyType 0:약품 2:주의약품 1:식품 9:기타
  const sub = SUBS[subType];

  const request211 = (symptomDT, symptomType, symptomInfo) => {
    PostApi211(
      userinfo,
      cfg,
      phonecfg,
      allergyType,
      foodId,
      medicineId,
      symptomDT,
      symptomType,
      symptomInfo
    ).then(res => {
      if (res.resultMsg === "SUCCESS") {
        setSearchMode(0);
        request261(allergyType);
      } else {
        openAlertPopup("저장실패");
      }
    });
  };

  const request213 = allergyId => {
    PostApi213(userinfo, cfg, phonecfg, allergyId, allergyType).then(res => {
      if (res.resultMsg === "SUCCESS") {
        request261(allergyType);
      } else {
        openAlertPopup("다시 로그인하세요.");
      }
    });
  };

  const request214 = (foodName, symptomDT, symptomType, symptomInfo) => {
    PostApi214(
      userinfo,
      cfg,
      phonecfg,
      allergyType,
      foodId,
      foodName,
      symptomDT,
      symptomType,
      symptomInfo
    ).then(res => {
      if (res.resultMsg === "SUCCESS") {
        setSearchMode(0);
        request261(allergyType);
      } else {
        openAlertPopup("다시 로그인하세요.");
      }
    });
  };

  const request216 = (allergyId, symptomDT, symptomType, symptomInfo) => {
    PostApi216(
      userinfo,
      cfg,
      phonecfg,
      allergyId,
      allergyType,
      foodId,
      symptomDT,
      symptomType,
      symptomInfo
    ).then(res => {
      if (res.resultMsg === "SUCCESS") {
        request261(allergyType);
        setSaveMode(0);
      } else {
        openAlertPopup("다시 로그인하세요.");
      }
    });
  };

  const request261 = allergyType => {
    PostApi261(userinfo, cfg, phonecfg, allergyType)
      .then(res => {
        if (res.resultMsg === "SUCCESS" && res.resultList.length > 0) {
          setAllergyList(res.resultList);
        } else {
          // 인터페이스 에러
          setAllergyList(null);
        }
      })
      .catch(err => {
        console.log(err);
        setAllergyList(null);
      });
  };

  const request262 = (medicineId, searchValue) => {
    PostApi262(
      userinfo,
      cfg,
      phonecfg,
      medicineId,
      searchValue,
      allergyType,
      pageNo,
      pageCnt
    )
      .then(res => {
        if (res.resultMsg === "SUCCESS" && res.resultList.length > 0) {
          setSearchList(res.resultList);
        } else {
          // 인터페이스 에러
          setSearchList(null);
        }
      })
      .catch(err => {
        console.log(err);
        setSearchList(null);
      });
  };

  const request263 = medicineId => {
    PostApi263(userinfo, cfg, phonecfg, medicineId, pageNo, pageCnt)
      .then(res => {
        if (res.resultMsg === "SUCCESS" && res.resultList.length > 0) {
          setResultList(res.resultList);
        } else {
          // 인터페이스 에러
          openAlertPopup("다시 로그인하세요.");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request264 = foodId => {
    PostApi264(userinfo, cfg, phonecfg, allergyType, foodId, pageNo, pageCnt)
      .then(res => {
        if (res.resultMsg === "SUCCESS" && res.resultList.length > 0) {
          setResultList(res.resultList);
        } else {
          // 인터페이스 에러
          openAlertPopup("다시 로그인하세요.");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const resetPopup = () => {
    $("#symptomInfo").val("");
    $("#certain").prop("checked", true);
    $("#timeCheck").prop("checked", false);

    $("#selectYear").css("display", "");
    $("#selectMonth").css("display", "");
  };

  const openAddPopup = (foodId, medicineId, medicineName) => {
    resetPopup();
    openLayerFn($("#listDetailPopup"));
    // $("#addPopupTitle").text(medicineName);
    setMedicineText(medicineName);
    setFoodId(foodId);
    setMedicineId(medicineId);
    setSaveMode(0);

    userHabit(phonecfg, "AL100_P02");
  };

  const openModPopup = (
    foodId,
    medicineId,
    medicineName,
    symptomDT,
    symptomInfo,
    symptomType,
    allergyId
  ) => {
    openLayerFn($("#listDetailPopup"));
    $("#addPopupTitle").text(medicineName);
    setFoodId(foodId);
    setMedicineId(medicineId);
    setAllergyId(allergyId);
    setSaveMode(1);

    resetPopup();

    $("#symptomInfo").val(symptomInfo);

    if (symptomType === "1") {
      $("#certain").prop("checked", true);
    } else {
      $("#suspect").prop("checked", true);
    }

    if (symptomDT === "모름") {
      $("#timeCheck").prop("checked", true);

      $("#selectYear").css("display", "none");
      $("#selectMonth").css("display", "none");
    } else {
      $("#selectYear").text(symptomDT.substring(0, 4) + "년");
      $("#selectMonth").text(symptomDT.substring(4, 6) + "월");
    }
    userHabit(phonecfg, "AL100_P02");
  };

  const handleCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  const handleConfirmCB = () => {
    request213(dialog.allergyId);
  };

  const openDetailPopup = (foodId, medicineId, medicineName) => {
    $("#detailPopup").show();
    $("#title").text(medicineName);

    if (foodId == "00") {
      request263(medicineId);
    } else {
      request264(foodId);
    }

    userHabit(phonecfg, "AL100_P01");
  };

  const openSearchPage = () => {
    setSearchMode(1);
    setSearchList(null);
  };

  const deleteAllergy = (title, msg, allergyId) => {
    setDialog({
      title: title,
      msg: msg,
      allergyId: allergyId,
    });

    openLayerFn($(".confirm-layer"));
  };

  const saveAllergy = (year, month, symptomType, symptomInfo, foodName) => {
    let symptomDT;

    if ($("#timeCheck").is(":checked") == true) {
      symptomDT = "모름";
    } else {
      symptomDT = year.substring(0, 4);
      if (month.length > 2) {
        symptomDT = symptomDT + month.substring(0, 2);
      } else {
        symptomDT = symptomDT + "0" + month.substring(0, 1);
      }
    }

    if (foodId == "00") {
      request211(symptomDT, symptomType, symptomInfo);
    } else {
      request214(foodName, symptomDT, symptomType, symptomInfo);
    }
    closeLayerFn($("#listDetailPopup"));
  };

  const modAllergy = (year, month, symptomType, symptomInfo) => {
    let symptomDT;

    if ($("#timeCheck").is(":checked") == true) {
      symptomDT = "모름";
    } else {
      symptomDT = year.substring(0, 4);
      if (month.length > 2) {
        symptomDT = symptomDT + month.substring(0, 2);
      } else {
        symptomDT = symptomDT + "0" + month.substring(0, 1);
      }
    }

    request216(allergyId, symptomDT, symptomType, symptomInfo);

    closeLayerFn($("#listDetailPopup"));
  };

  useEffect(() => {
    PostApi999(phonecfg, cfg, userinfo.userToken)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.resultList === 1) {
            request261(allergyType);
          } else {
            openLayerFn($(".alert-layer-logout"));
            // dispatch({ type: LOG_OUT_SUCCESS });
            // socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
            //   login: "out",
            //   userToken: "",
            // });
          }
        }
      })
      .catch(err => {
        // openLayerFn($('.alert-layer-logout'));
        // dispatch({ type: LOG_OUT_SUCCESS });
        // socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {"login":"out", "userToken":""});
        // openLayerFn($(".alert-layer-cnntFail"))
      });
  }, [allergyType]);

  useEffect(() => {
    let pageCd = "AL110";
    if (allergyType === 0) {
      pageCd = "AL110";
    } else if (allergyType === 2) {
      pageCd = "AL120";
    } else if (allergyType === 1) {
      pageCd = "AL130";
    } else {
      pageCd = "AL140";
    }
    userHabit(phonecfg, pageCd);
    NativeAction(phonecfg, "statusColor", "#B2BEE6");
  }, [phonecfg.version, allergyType]);

  return (
    <Fragment>
      <ScrollToTop />
      <Container
        Title={sub.label}
        goToUrl="/sm"
        color="purple"
        setMode={searchMode === 0 ? "" : setSearchMode}>
        <div className="contents sub priv">
          <SubMenu
            code={sub.code}
            allergyType={allergyType}
            setAllergyType={setAllergyType}
            setSearchMode={setSearchMode}
          />

          <div className="sub-contents">
            <div className="section-box">
              <div className="gauge-info-contain">
                {searchMode === 0 ? (
                  <Fragment>
                    {allergyList && allergyList.length > 0 ? (
                      allergyList.map((m, i) => (
                        <Contents
                          list={m}
                          openDetailPopup={openDetailPopup}
                          deleteAllergy={deleteAllergy}
                          openAddPopup={openAddPopup}
                          openModPopup={openModPopup}
                          allergyType={allergyType}
                          key={"allergyList" + i}
                        />
                      ))
                    ) : (
                      <Nothing />
                    )}
                    <BtnAdd eventHandle={() => openSearchPage()} />
                  </Fragment>
                ) : (
                  <Fragment>
                    {allergyType === 0 && (
                      <Fragment>
                        <div className="wbox-select-list">
                          <Search
                            searchList={searchList}
                            request262={request262}
                          />
                          {searchList && searchList.length > 0 ? (
                            // ?   searchList.map((m,i) => <SearchList searchList={m} openDetailPopup={openDetailPopup} openAddPopup={openAddPopup} key={"searchList"+i}/>)
                            searchList.map((m, i) => (
                              <ContentsList
                                list={m}
                                title={m.medicineName}
                                allergyType="00"
                                targetId={m.medicineId}
                                targetName={m.medicineName}
                                openAddPopup={openAddPopup}
                                openDetailPopup={openDetailPopup}
                                key={"c" + i}
                              />
                            ))
                          ) : (
                            <SearchDefaultMdcn
                              openDetailPopup={openDetailPopup}
                              openAddPopup={openAddPopup}
                              allergyType={allergyType}
                            />
                          )}
                        </div>
                      </Fragment>
                    )}
                    {allergyType === 2 && (
                      <div className="wbox-select-list">
                        <SearchDefaultMdcn
                          openDetailPopup={openDetailPopup}
                          openAddPopup={openAddPopup}
                          allergyType={allergyType}
                        />
                      </div>
                    )}
                    {allergyType === 1 && (
                      <AllergyImgList
                        type={allergyFood}
                        openAddPopup={openAddPopup}
                        allergyType={allergyType}
                      />
                    )}
                    {allergyType === 9 && (
                      <AllergyImgList
                        type={allergyEtc}
                        openAddPopup={openAddPopup}
                        allergyType={allergyType}
                      />
                    )}
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>
      <AlertPopup color="priv" />
      <ConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleConfirmCB}
        handleCancelCB={handleCancelCB}
      />
      <ListPopup color="priv" />
      <ListDetailPopup
        saveAllergy={saveAllergy}
        modAllergy={modAllergy}
        saveMode={saveMode}
        foodId={foodId}
        searchMode={searchMode}
        medicineText={medicineText}
      />
      <DetailPopup resultList={resultList} color="priv" />
    </Fragment>
  );
});
